import React from 'react';
import Icon from '../../../components/AppIcon';

const ApprovalFilters = ({ filters, onChange }) => {
  const handleChange = (key, value) => {
    onChange({ ...filters, [key]: value });
  };

  return (
    <div className="flex flex-wrap items-center gap-3 mb-4">
      {/* Search */}
      <div className="relative flex-1 min-w-[180px] max-w-xs">
        <Icon name="Search" size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          placeholder="Search customer..."
          value={filters?.search ?? ''}
          onChange={(e) => handleChange('search', e?.target?.value)}
          className="w-full pl-9 pr-3 py-2 text-sm border border-border rounded-lg bg-background focus:outline-none focus:ring-2 focus:ring-primary/30"
        />
      </div>
      {/* Type */}
      <select
        value={filters?.type ?? 'all'}
        onChange={(e) => handleChange('type', e?.target?.value)}
        className="px-3 py-2 text-sm border border-border rounded-lg bg-background focus:outline-none focus:ring-2 focus:ring-primary/30"
      >
        <option value="all">All Types</option>
        <option value="ticket">Tickets</option>
        <option value="quote">Quotes</option>
      </select>
      {/* Status */}
      <select
        value={filters?.status ?? 'all'}
        onChange={(e) => handleChange('status', e?.target?.value)}
        className="px-3 py-2 text-sm border border-border rounded-lg bg-background focus:outline-none focus:ring-2 focus:ring-primary/30"
      >
        <option value="all">All Statuses</option>
        <option value="pending">Pending</option>
        <option value="approved">Approved</option>
        <option value="rejected">Rejected</option>
        <option value="expired">Expired</option>
      </select>
      {/* Date Range */}
      <select
        value={filters?.dateRange ?? '30d'}
        onChange={(e) => handleChange('dateRange', e?.target?.value)}
        className="px-3 py-2 text-sm border border-border rounded-lg bg-background focus:outline-none focus:ring-2 focus:ring-primary/30"
      >
        <option value="7d">Last 7 days</option>
        <option value="30d">Last 30 days</option>
        <option value="90d">Last 90 days</option>
        <option value="all">All time</option>
      </select>
    </div>
  );
};

export default ApprovalFilters;
